import React, { lazy } from 'react';
export function Hero() {
  return <section className="relative w-full flex flex-col items-center justify-center overflow-hidden bg-[#0d0d0d] pt-[10px] pb-[10px]" style={{
    contain: 'layout style paint',
    minHeight: '100svh'
  }} data-id="element-44">
      <div className="relative z-10 max-w-5xl mx-auto px-4 text-center flex flex-col items-center" data-id="element-45">
        <div className="tracking-[0.2em] md:text-base flex items-center text-[20px] font-[900] text-[#FFD900] mb-[5px] gap-[0px]" data-id="element-46">
          <span data-id="element-47">🎵</span> PROFEPACK
        </div>

        <h1 className="md:text-7xl lg:text-8xl text-white mb-[0px] text-[28px] font-[900] font-sans" data-id="element-48">
          Todo tu año de Arte <br data-id="element-49" />
          <span className="text-[#FFD900]" data-id="element-50">resuelto.</span>
        </h1>

        <div className="mb-2 md:mb-4 w-full max-w-[220px] md:max-w-[270px] relative" data-id="element-51">
          <img src="https://cdn.magicpatterns.com/uploads/xvaNrVxGCwEv9Y5XE9atzn/Diseno-sin-titulo-_19_.webp" alt="Mega Pack Artística Lista" className="w-full h-auto" fetchPriority="high" decoding="sync" loading="eager" width="270" height="270" data-id="element-52" />
        </div>

        <h2 className="md:text-3xl font-bold italic text-[18px] text-[#FFD900] font-sans mb-[6px] md:mb-[10px]" data-id="element-53">
          "Listo para usar. Sin buscar más."
        </h2>

        <p className="text-gray-300 text-sm md:text-lg max-w-3xl mx-auto leading-relaxed mb-[8px] md:mb-[10px]" data-id="element-54">
          El sistema que usan{' '}
          <strong className="text-white" data-id="element-55">+2.000 docentes de Arte</strong> de
          primaria y secundaria en Argentina para planificar todo el año en una
          tarde — sin improvisar, sin buscar y sin perder domingos.
        </p>

        <div className="w-full max-w-md mx-auto mb-[12px] md:mb-[20px]" data-id="element-56">
          <a href="#comprar" onClick={e => {
          e.preventDefault();
          const el = document.getElementById('comprar');
          if (el) {
            const top = el.getBoundingClientRect().top + window.scrollY - 40;
            window.scrollTo({
              top,
              behavior: 'smooth'
            });
          }
        }} className="block w-full text-black px-8 py-4 md:py-5 rounded-xl font-black md:text-2xl hover:bg-[#fcd34d] hover:scale-105 transition-all duration-300 bg-[#FFD900] pt-[14px] pb-[14px] md:pt-[20px] md:pb-[20px] text-[18px] pl-[0px] pr-[0px]" data-id="element-57">
            🎨 → QUIERO MI PROFEPACK AHORA
          </a>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-6" data-id="element-58">
          <span className="border border-[#2a2a2a] bg-[#141414] rounded-full px-4 py-2 text-sm text-gray-300 flex items-center gap-2" data-id="element-59">
            📄 100% PDF
          </span>
          <span className="border border-[#2a2a2a] bg-[#141414] rounded-full px-4 py-2 text-sm text-gray-300 flex items-center gap-2" data-id="element-60">
            ⚡ Acceso inmediato
          </span>
          <span className="border border-[#2a2a2a] bg-[#141414] rounded-full px-4 py-2 text-sm text-gray-300 flex items-center gap-2" data-id="element-61">
            🇦🇷 Currículo argentino
          </span>
        </div>
      </div>
    </section>;
}